import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { Progress } from "../../../nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import QueueingViewPresenter from "./QueueingViewPresenter";
import Upnext from "./components/Upnext";
import QueueVideo from "./components/QueueVideo";
import QueueCarousel from "./components/QueueCarousel";
import NowServingWithSpeech from "./NowServingWithSpeech";
import { formatDate, formatTime } from "./utils/utils";
import QueueVideo2 from "./components/QueueVideo2";
import Header from "./components/Header";

class QueueingListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new QueueingViewPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      speechConfig: {},
      recruiters: [],
      progress: false,
      others: [],
      currentTime: new Date(),
      currentIndex: 0,
      images: [
        "./1.jpg",
        "./2.jpg",
        "./3.jpg",
        "./4.jpg",
        "./5.jpg",
        "./6.jpg",
        "./7.jpg",
      ],
    };
  }

  getCollectionName() {
    return "queue";
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    // this.interval = setInterval(this.nextSlide, 3000);

    // this.timeInterval = setInterval(() => {
    //   this.setState({ currentTime: new Date() });
    // }, 1000);

    //TEMPORARY REMOVED/COMMENTED
    // this.pageRefreshInterval = setInterval(() => {
    //   window.location.reload();
    // }, 3600000);
  }

  componentWillUnmount() {
    super.componentWillUnmount?.();
    clearInterval(this.timeInterval);
    clearInterval(this.interval);
    if (this.presenter) {
      this.presenter.stopPolling();
    }
  }

  nextSlide = () => {
    this.setState((prevState) => ({
      currentIndex:
        prevState.currentIndex === prevState.images?.length - 1
          ? 0
          : prevState.currentIndex + 1,
    }));
  };

  setRecruiter(recruiters) {
    this.setState({ recruiters: recruiters });
  }
  setOthers(others) {
    this.setState({ others: others });
  }

  setObjects2(objects2) {
    this.setState({ objects2 });
  }

  setConfig(object) {
    this.setState({ speechConfig: object });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      currentTime,
      currentIndex,
      images,
      recruiters,
      others,
      speechConfig,
    } = this.state;
    const formattedTime = formatTime(currentTime);
    const formattedDate = formatDate(currentTime);
    const nowServing = objects;
    const upNext = objects;
    // const recruiters = this.state.recruiter || [];
    const half = Math.ceil(recruiters.length / 2);
    // const leftColumn = recruiters;
    // const rightColumn = others;
    const leftColumn = recruiters.slice(0, half);
    const rightColumn = recruiters.slice(half);

    if (!schema) return <Progress />;
    return (
      <>
        <div
          className="p-6 bg-gray-50 min-h-screen"
          style={{ backgroundColor: "#f3f3ef" }}
        >
          <div className="row">
            <div className="container mt-3 col-8">
              <Header
                formattedTime={formattedTime}
                formattedDate={formattedDate}
              />
              <NowServingWithSpeech
                nowServing={nowServing}
                speechConfig={speechConfig}
              />
            </div>
            <div className="col-4">
              <QueueVideo />
              <QueueVideo2 />
              {/* <QueueCarousel images={images} currentIndex={currentIndex} /> */}
            </div>
            <div>
              <Upnext upNext={upNext} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(QueueingListPage);
